import SearchInput from './SearchInput';

export default SearchInput;
export * from './SearchInput';
